<template>
  <div>
    <div class="card-header" :class="headerClass">
      <slot name="card-header"></slot>
    </div>

    <div class="card-body" :class="bodyClass">
      <slot name="card-body"></slot>
    </div>

    <template v-if="view === 'block'">
      <div class="card-footer" :class="footerClass"
        v-if="this.$slots['card-footer']"
      >
        <ul class="mb-0 list-unstyled">
          <slot name="card-footer"></slot>
        </ul>
      </div>

      <div class="card-actions" :class="actionsClass"
        v-if="this.$slots['card-actions']"
      >
        <slot name="card-actions"></slot>
      </div>
    </template>

    <template v-if="view === 'list'">
      <div class="d-flex-col d-xs-flex justify-content-between">
        <div class="card-footer pr-1 flex-grow-1" :class="footerClass"
          v-if="this.$slots['card-footer']"
        >
          <ul class="mb-0 list-unstyled">
            <slot name="card-footer"></slot>
          </ul>
        </div>

        <div class="card-actions" style="min-width: 340px;" :class="actionsClass"
          v-if="this.$slots['card-actions']"
        >
          <slot name="card-actions"></slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'searchBlockBaseContent',
  props: {
    index: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    headerClass: {
      type: String,
      default: ''
    },
    footerClass: {
      type: String,
      default: ''
    },
    bodyClass: {
      type: String,
      default: ''
    },
    actionsClass: {
      type: String,
      default: ''
    },
    view: {
      type: String,
      default: 'block',
      validator: (val) => ['block', 'list'].includes(val)
    }
  }
}
</script>
